import React from "react";
import PropTyeps from "prop-types";

import "./footer.css";

export default function ClearCompleted(props) {
  const { onClear, onGroup } = props;
  return (
    <React.Fragment>
      <button className="clearButton" onClick={onClear}>
        Clear Completed
      </button>
      <button className="groupButton" onClick={onGroup}>
        Group Todos
      </button>
    </React.Fragment>
  );
}

ClearCompleted.propTypes = {
  onClear: PropTyeps.func.isRequired,
  onGroup: PropTyeps.func.isRequired
};
